export const PAGE_SIZE_ALL = 'all';

// Helper class for making pages for display
